import { formatearFecha } from '../../helpers/helper'
import { Responder } from './Responder'

export const Respuesta = ({
  respuesta,
  usuario,
  mensaje,
  texto,
  errores,
  handleChange,
  submitRespuesta,
  valido
}) => {
  const respuestas = Array.isArray(respuesta) ? respuesta : respuesta.respuestas || []

  return respuestas.map((resp) => (
    <div key={resp.idMensaje} className="ms-4 text-secondary position-relative mb-2">
      <div className="respuestaFlecha"></div>

      <p className="texto-respuesta">
        {resp.texto}
        <br />
        <small className="ml-2">{formatearFecha(resp.fechaEscrito, 'FH', 'hs')}</small>
      </p>

      {resp.respuestas && resp.respuestas.length > 0 ? (
        <Respuesta
          respuesta={resp.respuestas}
          usuario={usuario}
          mensaje={mensaje}
          texto={texto}
          errores={errores}
          handleChange={handleChange}
          submitRespuesta={submitRespuesta}
          valido={valido}
        />
      ) : (
        <Responder
          idComprador={mensaje.idComprador}
          idVendedor={mensaje.idVendedor}
          idUsuarioChat={resp.idUsuarioChat}
          idMensaje={resp.idMensaje}
          usuario={usuario}
          handleChange={handleChange}
          texto={texto}
          errores={errores}
          submitRespuesta={submitRespuesta}
          valido={valido}
          mensaje={mensaje}
        />
      )}
    </div>
  ))
}
